import { LoginPage } from './../login/login';
import { Component, ViewChild } from '@angular/core';
import { NavController, Slides, ToastController, LoadingController, NavParams } from 'ionic-angular';
import { StoryProvider } from '../../providers/story/story';
import { CoverPage } from '../cover/cover';
import { Subscription } from 'rxjs/Subscription';
import { AuthDataProvider } from '../../providers/auth-data/auth-data';
import { AngularFireAuth } from 'angularfire2/auth';
//import { PresignupPage } from '../presignup/presignup';
import { ProfilePage } from '../profile/profile';
import * as $ from 'jquery';
//import * as firebase from 'firebase';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {
  @ViewChild('mainSlider') mainSlider: Slides;

  public categories: any;
  public currentIndex: any;
  public AuthSubscription: Subscription;
  public session: any;
  public userInfo: any;
  stories: any;
  items = [];
  public newcat: any;
  public showNoMessage: boolean = false;
  public photo: any;
  public gender: any;
  public preference: any;
  public myPhoto: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public storieProvider: StoryProvider,
    public authData: AuthDataProvider,
    public afAuth: AngularFireAuth,
    private toast: ToastController,
    public loadingCtrl: LoadingController
  ) {
    if (!this.preference) {
      this.presentLoadingDefault()
    } else {
      console.log("NO EXISTE PREFERENCIA");
    }
  }

  //////////////////////////////////////////////////////////////////
  ionViewDidLoad() {
  }

  /////////////////////////////////////////////////////////////////
  ionViewCanEnter() {
    let ion = this;
    ion.getCategoriesAndStories();
    this.AuthSubscription = this.afAuth.authState.subscribe(userAuth => {

      //console.log("dejame entender algo", userAuth);
      if (userAuth && userAuth.email && userAuth.uid) {
        console.log('auth true login, moving HomePage', userAuth.email);
        // this.authData.getUserProfile().then(function (res) {
        //   ion.userInfo = res;
        // });

        this.authData.getUserEmail(userAuth.email).then(function (resEmail) {
          ion.userInfo = resEmail;
          // console.log("julio info del arreglo de user retorno", ion.userInfo);
        })

        this.authData.setUserData().then(() => {
          this.AuthSubscription.unsubscribe();
          ion.session = true;
          this.toast.create({
            message: 'Bienvenidos a DirtyTalk, ' + userAuth.email,
            duration: 3000
          }).present();
        });



        // ion.authData.getUserEmail(this.afAuth.auth.currentUser.email).then(resdevice => {
        ion.authData.getUserProfile().then(resdevice => {
          ion.preference = resdevice.preference
          ion.userInfo = resdevice;
          ion.photo = resdevice.photo;
          ion.gender = resdevice.gender;

          if (ion.photo === 'default' && ion.gender === 'M') {
            this.myPhoto = "/../../assets/imgs/male.jpg";
            if (ion.photo === 'default' && ion.gender === 'F') {
              this.myPhoto = "/../../assets/imgs/female.jpg";
            }
          } else {
            this.myPhoto = ion.photo;
          }
        });



      } else {
        this.AuthSubscription.unsubscribe();
        ion.session = false;
        this.authData.getUserProfile().then(function (res) {
          ion.userInfo = res;
          // console.log("auth false, continue login!", ion.userInfo)
        });
      }
    });
  }

  presentLoadingDefault() {
    let loading = this.loadingCtrl.create({
      spinner: 'bubbles',
      content: 'Cargando Historias...',
      showBackdrop: false
    });
    loading.present();
    setTimeout(() => {
      loading.dismiss();
    }, 4000);
  }

  getCategoriesAndStories() {
    let ion = this;
    ion.storieProvider.getCategoriesWithStories()
      .then(result => {

        //console.log("Historias por Categorias", result);
        this.newcat = Object.keys(result).map(function (storyNamedIndex) {
          let storyCat = result[storyNamedIndex];
          // console.log("HISTORIAS DE CADA CATEGORIA", storyCat);

          return storyCat;
        });

        let newArrayStories = [];
        let newArrayNewStories = [];
        let newArrayPopStories = [];
        let newArrayReadingStories = [];
        let dateNow = new Date().getTime() / 1000;
        console.log(dateNow);
        // console.log("TODAS LAS CATEGORIAS CON SUS HISTORIAS", this.newcat);
        this.newcat.forEach(category => {
          category.stories.forEach(story => {
            story.$key
            newArrayStories.push(story);
            if (story.date.seconds > (dateNow - 2592000)) {
              newArrayNewStories.push(story);
            }

            if (story.view > 1000) {
              newArrayPopStories.push(story);
            }
            let idStoryReading = false;
            idStoryReading = this.findReading(story);
            if (idStoryReading != false) {
              newArrayReadingStories.push(story);
            }
          });
        });

        console.log('HISTORIAS LEIDAS POR ESTE USUARIO', newArrayReadingStories);

        newArrayStories = this.findView(newArrayStories);

        this.newcat.unshift({ name: 'leídos', stories: newArrayReadingStories })
        this.newcat.unshift({ name: 'populares', stories: newArrayPopStories })
        this.newcat.unshift({ name: 'nuevos', stories: newArrayNewStories })

        ion.spliceStories(this.newcat).then(resTotal => {

          ion.categories = resTotal;



          for (let index = 0; index < ion.categories.length; index++) {
            const IDcategorie = ion.categories[index];
            // ion.navParams.data.categorieID = ion.categories[index].name;
            console.log("CATEGORIA DE LA HISTORIA", ion.categories[index].name);

          }


          // ion.categories.forEach(IDcat => {
          //   ion.navParams.data.categorieID = ion.categories[IDcat].name;
          //   console.log("CATEGORIA DE LA HISTORIA", ion.categories[IDcat].name);
          // });


          setTimeout(() => { ion.startMenuSlider(); }, 2);
        })
      })
      .catch(err => {
        console.log('some error happend', err);
      });


  }

  findView(stories) {
    stories.sort(function (a, b) {
      if (a.view < b.view) { return 1; }
      else if (a.view == b.view) { return 0; }
      else { return -1; }
    });

    stories = stories.slice(0, 10);
    return stories;
  }

  findReading(story) {
    // sort descending
    let ion = this;
    // console.log("q cono estoy mandando", story.$key);

    let inforeading = false;
    //SI SE ENTRA POR PRIMERA VEZ SE VALIDA QUE NO HAYAN LEIDOS.
    if (ion.userInfo) {
      for (let item of ion.userInfo.reading) {
        if (story.$key === item.story_id) {
          inforeading = true;
        }
      }
    }
    return inforeading;
  }

  register() {
    let ion = this;
    if (ion.session === true) {
      ion.navCtrl.push(ProfilePage, { profile: ion.userInfo });
    } else {
      ion.navCtrl.push(LoginPage);
    }
  }

  goCover(storie) {
    let ion = this;
    ion.navCtrl.push(CoverPage, {
      data: {
        storie: storie,
        session: ion.session,
        userInfo: ion.userInfo
      }
    });
  }

  spliceStories(categories) {
    return new Promise((resolve, reject) => {
      let asd = 0;
      categories.forEach(categorie => {
        // console.log("CATEGORIASSSSS", categorie.stories.length);
        if (categorie.stories.length === 0) {
          categorie.showNoMessage = false;
        } else {
          categorie.showNoMessage = true;
        }

        asd++;
        let halfStories = Math.floor(categorie.stories.length / 2);
        categorie.leftStories = categorie.stories.slice(0, halfStories);
        categorie.rightStories = categorie.stories.slice(halfStories, categorie.stories.length);
        if (asd == categories.length) {
          resolve(categories);
        }
      });
    })
  }

  startMenuSlider() {
    let ion = this;
    let currentObj = ion.categories.filter((categorie, i) => {
      return i === ion.mainSlider.getActiveIndex()
    })
    document.getElementById(currentObj[0].name).classList.add('active');
  }

  mainSlideChanged() {
    let ion = this;
    // Get current slide object by slide index
    let currentObj = ion.categories.filter((categorie, i) => {
      return i === ion.mainSlider.getActiveIndex()
    })


    console.log('active index slide', ion.mainSlider.getActiveIndex());

    // Insert current index object on main
    ion.currentIndex = {
      index: (ion.mainSlider.getActiveIndex()),
      object: currentObj[0]
    }
    // Call click on a element in view
    if (ion.currentIndex.object) {
      document.getElementById(ion.currentIndex.object.name).click();
    }

  }

  runEffect(e, categorie) {
    let ion = this;
    // Insert current index object on main
    ion.currentIndex = {
      index: (ion.categories.indexOf(categorie)),
      object: categorie
    };
    // Call slide to index by main current index obj
    ion.mainSlider.slideTo(ion.currentIndex.index);
    // Get menu dom
    let menu = document.getElementById("menu");
    let $menu = $('.menu');
    // Remove all active class on all menu el's
    let menuElements = menu.getElementsByTagName('a');
    for (var i = 0; i < menuElements.length; i++) {
      menuElements[i].classList.remove('active');
    }
    // Add active class to selected el
    e.classList.add('active');
    // Get element offSet and Width
    let elOffsetLeft = $(e).offset().left;
    let elWidth = e.offsetWidth;
    // Get menu offSet and Width
    let menuScrollLeft = menu.scrollLeft;
    let menuWidth = menu.offsetWidth;
    // Calculate Scroll Position
    let myScrollPos = elOffsetLeft + (elWidth / 2) + menuScrollLeft - (menuWidth / 2);
    // Animate and scroll to myScrollPos
    $menu.animate({
      scrollLeft: myScrollPos
    }, 200);
  }

  entrar() {
    this.navCtrl.push(CoverPage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts